import React from 'react';
import cx from 'classnames';
import linkBg from '../image/link-bg-2.png.js';
import star1 from '../image/star-1.png.js';
import star2 from '../image/star-2.png.js';
import star3 from '../image/star-3.png.js';
import styles from './index.module.scss.js';

const NavigationLink = ({
  active,
  onClick,
  icon,
  label,
  id,
  v2
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    type: "button",
    className: cx(styles.box, {
      [styles.active]: active,
      [styles.v2]: v2
    }),
    key: id,
    onClick: () => {
      onClick(id);
    }
  },
  !v2 && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles.bg,
      src: linkBg,
      alt: "navigation list background"
    }
  ),
  !v2 && active && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["star-1"],
      src: star1,
      alt: "navigation list star1"
    }
  ),
  !v2 && active && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["star-2"],
      src: star2,
      alt: "navigation list star2"
    }
  ),
  !v2 && active && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["star-3"],
      src: star3,
      alt: "navigation list star3"
    }
  ),
  icon && /* @__PURE__ */ React.createElement("div", { className: styles.icon }, icon),
  /* @__PURE__ */ React.createElement("span", { className: styles.text }, label)
);

export { NavigationLink as default };
//# sourceMappingURL=index.js.map
